import React from 'react';
import Price from '@synergycms_core/components/generic/Price';
import RichText from '@synergycms_core/components/generic/RichText';

import { Loading } from '@synergycms_core/components/functional/Loading';

export const EquivalentPrice = props =>
  props.hotelCurrencyCode !== props.currentCurrencyCode && (
    <div>
      <RichText
        text={'_%importe equivalente a%_ '}
        innerStyle={['roboto11SoftGray400']}
        ucFirst={true}
        translate={true}
      />{' '}
      <Price innerStyle={['summaryPriceExtraSmall']} amount={props.totalPrice} forceHotelCurrency={true} />
    </div>
  );

export const OldPrice = props =>
  props.discountPercent >= 5 && (
    <Price innerStyle={['summaryPriceLittle']} amount={props.amount + props.discountAmount} ariaHidden={true}/>
  );

export const TaxIncluded = props =>
  props.showTaxes && (
    <RichText text={'_%impuestos incluidos%_'} innerStyle={['roboto11SoftGray400']} ucFirst={true} translate={true} />
  );

export const LoadingFragment = () => (
  <React.Fragment>
    <Loading
      richText={{
        innerStyle: ['descriptionText'],
        ucFirst: true,
        text: '_%estamos procesando su reserva%_',
        translate: true
      }}
    />
  </React.Fragment>
);

export const LoadingConfirmation = () => (
  <React.Fragment>
    <Loading
      richText={{
        innerStyle: ['descriptionText'],
        ucFirst: true,
        text: '_%estamos confirmando su reserva%_',
        translate: true
      }}
    />
  </React.Fragment>
);

export class EPGContainer extends React.Component {
  static displayName = 'EPGContainer';

  render() {
    const { tpvEnabled, epgCashierContainer, epgPrepayToken, payFormSelected, reservationPaid, UserLoggedST } = this.props;
    return (
      !UserLoggedST && tpvEnabled === 'EPG' && !reservationPaid && (
        <span>
          <div
            id={epgCashierContainer}
            // Els estils son en linia per aconseguir ser mes restrictius que els del HTML
            style={payFormSelected === 'op' && epgPrepayToken === false ? { display: 'block' } : { display: 'none' }}
          />
        </span>
      )
    );
  }
}
